import cx from 'classnames'
import config from 'config'
import { routeData } from 'links'
import { useDevice } from 'device'
import React, { useMemo } from 'react'

import { Text } from 'components/dataDisplay'

import { Grid } from 'components/layout'

import useServices from './util/useServices'
import ServiceCard from './components/ServiceCard/ServiceCard'
import ServiceCardSmall from './components/ServiceCardSmall/ServiceCardSmall'


type ServicesBlockProps = {
  className?: string
  modules: UserModel.PublicModuleTag[]
}

const ServicesBlock: React.FC<ServicesBlockProps> = (props) => {
  const { className, modules } = props

  const { isMobile, isTablet } = useDevice()

  const { services, marketplaceServices } = useServices()

  const filteredMarketplaceServices = useMemo(() => (
    marketplaceServices.filter((service) => {
      return modules?.includes(routeData[service.to]?.tag)
    })
  ), [ marketplaceServices, modules ])

  const filteredServices = useMemo(() => (
    services.filter((service) => modules?.includes(routeData[service.to]?.tag))
  ), [ modules, services ])

  return (
    <div className={cx(className)}>
      {
        Boolean(filteredServices.length || filteredMarketplaceServices.length) && (
          <Text
            message={`Сервисы и службы ${config.cityName !== 'Пуровский район' ? 'города' : 'района'}`}
            size={isMobile ? 'h20-28' : 'h32'}
            color="titanic"
          />
        )
      }
      {
        Boolean(filteredServices.length) && (
          <Text
            className="mt-32px opacity-72"
            message="Информационные сервисы"
            size="t16-24"
            color="gladiator"
          />
        )
      }
      <Grid
        className="pt-24px"
        align="start"
        justify="start"
        columns={isMobile ? 2 : isTablet ? 3 : 6}
        gutter={isMobile ? 16 : isTablet ? 24 : 32}
      >
        {
          filteredServices.map((service, index) => (
            <ServiceCardSmall
              key={index}
              to={service.to}
              title={service.title}
              image={service.image}
            />
          ))
        }
      </Grid>
      {
        Boolean(filteredMarketplaceServices.length) && (
          <Text
            className="mt-40px opacity-72"
            message="Сервисы бронирования и оплаты"
            size="t16-24"
            color="gladiator"
          />
        )
      }
      {
        isMobile ? (
          <Grid
            className="pt-24px"
            align="start"
            justify="start"
            columns={2}
            gutter={16}
          >
            {
              filteredMarketplaceServices.map(({ title, to, image }, index) => ( // TODO add license check
                <ServiceCardSmall
                  key={index}
                  title={title}
                  to={to}
                  image={image}
                />
              ))
            }
          </Grid>
        ) : (
          <div className={cx('mt-24px', isTablet ? '' : 'flex')}>
            {
              filteredMarketplaceServices.map(({ title, text, to, image }, index, array) => (
                <ServiceCard
                  key={index}
                  className={cx('flex-1', { 'ml-32px': index })}
                  title={title}
                  text={text}
                  to={to}
                  image={image}
                  imagePosition={filteredMarketplaceServices.length > 1 && !index ? 'center' : 'bottom'}
                />
              ))
            }
          </div>
        )
      }
    </div>
  )
}


export default ServicesBlock
